export default __webpack_public_path__ + "locales/ro/PrivacyPage.json?hash=e6650e52ebc554927d87eea234995b78";